export enum UsuarioControlDefs {
  USER = 'usuario',
  PASSWORD = 'senha',
}
